import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { FaAngleLeft } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import UserContext from "../../component/ContextApi/UserContext";
import AuthOutlineBtn, {
  AuthFillButton,
} from "../../component/ReUseComps/Button";
import languageImage from "../../../assets/addLanguage.png";
import { URLS } from "../../../Utils/App_urls";
import Select from "react-select";
import "./Language.css";
import "./BasicInfo.css";
import "./JobCity.css";
import axios from "axios";

export default function Language() {
  const { step, setStep, userForm, setUserForm } = useContext(UserContext);
  const [moreLanguageOption, setMoreLanguageOption] = useState([
    { languageFromMenu: "", proficiency: "" },
  ]);
  const [error, setError] = useState({ errorMessage: "", errorStatus: false });
  const [languageLists, setLanguageLists] = useState([]);
  const [selectedOption, setSelectedOption] = useState("none");
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const suggestedLanguage = ["Hindi", "English", "Bengali", "Marathi"];

  const proficiencyListOfLevel = [
    { value: "Basic", label: "Basic" },
    { value: "Intermediate", label: "Intermediate" },
    { value: "Advance", label: "Advance" },
  ];

  // Add a new language field
  const handleAddMoreLagOpt = () => {
    if (moreLanguageOption.length >= 5) {
      setError({
        errorMessage: "Maximum 5 languages can be added",
        errorStatus: true,
      });
      return;
    }
    setMoreLanguageOption((prev) => [
      ...prev,
      { languageFromMenu: "", proficiency: "" },
    ]);
    setError({ errorMessage: "", errorStatus: false });
  };

  // Remove a language field
  const handleRemoveLagOpt = (index) => {
    const removedLanguage = moreLanguageOption[index].languageFromMenu;
    setMoreLanguageOption((prevOptions) =>
      prevOptions.filter((_, id) => id !== index)
    );
    setSelectedLanguages((prev) =>
      prev.filter((lang) => lang !== removedLanguage)
    );
  };

  // Get all available languages from API
  const getAllLanguages = () => {
    axios
      .get(`${URLS.getLanguages}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      })
      .then((res) => {
        const langaugeResList = res?.data?.data || [];
        const formattedLangList = langaugeResList.map((lang) => ({
          value: lang?.name,
          label: lang?.name,
        }));
        setLanguageLists(formattedLangList);
      })
      .catch((err) => console.error(err));
  };

  // Handle language selection from dropdown
  const handleTypeSelect = (e, idx) => {
    setSelectedOption(e.value);
    setError({ errorMessage: "", errorStatus: false });
    setMoreLanguageOption((prev) =>
      prev.map((data, index) => {
        if (index === idx) {
          return {
            ...data,
            languageFromMenu: e.value,
          };
        }
        return data;
      })
    );
  };

  // Handle proficiency level change
  const handleProficiencyChange = (e, idx) => {
    setMoreLanguageOption((prev) =>
      prev.map((data, index) => {
        if (index === idx) {
          return { ...data, proficiency: e.value };
        }
        return data;
      })
    );
    setError({ errorMessage: "", errorStatus: false });
  };

  // Add suggested language
  const handleAddSuggestedLanguage = (language, index) => {
    // Check if already exists
    const existsInForm = moreLanguageOption.some(
      (item) => item.languageFromMenu === language
    );
    const existsInSelected = selectedLanguages.includes(language);

    if (existsInForm || existsInSelected) {
      setError({
        errorMessage: `${language} is already added`,
        errorStatus: true,
      });
      return;
    }

    // Add to form
    setMoreLanguageOption((prev) => [
      ...prev,
      { languageFromMenu: language, proficiency: "Basic" },
    ]);

    // Mark as selected
    setSelectedLanguages((prev) => [...prev, language]);
    setError({ errorMessage: "", errorStatus: false });
  };

  // Remove suggested language
  const handleRemoveSuggestedLanguage = (language) => {
    // Remove from form
    setMoreLanguageOption((prev) =>
      prev.filter((item) => item.languageFromMenu !== language)
    );

    // Remove from selected
    setSelectedLanguages((prev) => prev.filter((lang) => lang !== language));
  };

  // Check for duplicate languages
  const checkDuplicates = () => {
    const languages = moreLanguageOption.map((item) => item.languageFromMenu);
    const uniqueLanguages = new Set(languages);

    if (languages.length !== uniqueLanguages.size) {
      setError({
        errorMessage: "Duplicate languages are not allowed",
        errorStatus: true,
      });
      return false;
    }
    return true;
  };

  // Validate form before submission
  const validateForm = () => {
    // Check for empty fields
    const emptyFields = moreLanguageOption.some(
      (item) => !item.languageFromMenu || !item.proficiency
    );

    if (emptyFields) {
      setError({
        errorMessage: "Please complete all language selections",
        errorStatus: true,
      });
      return false;
    }

    // Check for duplicates
    if (!checkDuplicates()) return false;

    return true;
  };

  // Handle form submission
  const handleSubmitLag = () => {
    if (!validateForm()) return;

    setUserForm({
      ...userForm,
      language: moreLanguageOption.filter(
        (item) => item.languageFromMenu && item.proficiency
      ),
    });
    setStep((step) => step + 1);
  };

  // Navigate back
  const handleBackStep = () => {
    setUserForm((userForm) => ({ ...userForm, language: moreLanguageOption }));
    setStep((prev) => prev - 1);
  };

  // Initialize form data
  useEffect(() => {
    if (userForm?.language?.length > 0) {
      setMoreLanguageOption([...userForm.language]);
      setSelectedLanguages(
        userForm.language.map((item) => item.languageFromMenu)
      );
    }
    getAllLanguages();
  }, []);

  return (
    <div className="w-100 d-flex">
      <div className="language_main responsive_cont w-50 pt-3 pt-md-5 flex-grow-1">
        <h1 className="page-title-tag d-flex align-items-center m-0">
          <span onClick={handleBackStep} className="d-flex cursor-pointer">
            <FaAngleLeft />
          </span>
          Add Language
        </h1>

        {/* Language input fields */}
        {moreLanguageOption?.map((data, index) => (
          <div
            key={index}
            className="d-flex w-100 align-items-sm-center justify-content-start flex-sm-row flex-column flex-wrap gap-3 mb-3"
          >
            <div className="flex-grow-1">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <label htmlFor="languageSelect">Language</label>
                <div
                  className={`d-sm-none d-block d-flex align-items-center ${
                    moreLanguageOption?.length === 1
                      ? "d-none"
                      : index === 0 && "opacity-0"
                  }`}
                >
                  <IoMdClose
                    onClick={() => handleRemoveLagOpt(index)}
                    className="cursor-pointer"
                    fontSize={16}
                  />
                </div>
              </div>
              <div className="inbuild-selectOption">
                <Select
                  options={languageLists}
                  onChange={(e) => handleTypeSelect(e, index)}
                  value={languageLists.find(
                    (option) => option?.value === data?.languageFromMenu
                  )}
                  placeholder="Select Language"
                />
              </div>
            </div>

            <div className="flex-grow-1">
              <div className="mb-2">
                <label htmlFor="proficiencyLevel">Language Proficiency</label>
              </div>
              <div className="inbuild-selectOption">
                <Select
                  options={proficiencyListOfLevel}
                  onChange={(e) => handleProficiencyChange(e, index)}
                  value={proficiencyListOfLevel.find(
                    (option) => option.value === data?.proficiency
                  )}
                  placeholder="Select Proficiency"
                />
              </div>
            </div>

            <div
              className={`d-flex align-items-center remove-optionIcon h-100 ${
                moreLanguageOption?.length === 1
                  ? "d-none"
                  : index === 0 && "opacity-0"
              }`}
            >
              <IoMdClose
                onClick={() => handleRemoveLagOpt(index)}
                className="mt-4 cursor-pointer"
                fontSize={16}
              />
            </div>
          </div>
        ))}

        {/* Add more language button */}
        {moreLanguageOption?.length < 5 && (
          <div className="addMoreLang" onClick={handleAddMoreLagOpt}>
            <span>Add more language</span>
            <FaPlus fontSize={12} />
          </div>
        )}

        {/* Error message */}
        {error.errorMessage && (
          <p className="m-0 text-danger">{error.errorMessage}</p>
        )}

        {/* Suggested languages */}
        <div className="moreLanguageOptionBox mt-4">
          <h2>Suggested Languages</h2>
          <div className="d-flex gap-2 flex-wrap">
            {suggestedLanguage.map((language, index) => {
              const isSelected = selectedLanguages.includes(language);
              return (
                <button
                  key={index}
                  className={`otrLgnOptbx ${isSelected ? "lagSelect" : ""}`}
                  onClick={() =>
                    isSelected
                      ? handleRemoveSuggestedLanguage(language)
                      : handleAddSuggestedLanguage(language, index)
                  }
                >
                  <span>{language}</span>
                  {isSelected ? (
                    <span className="removeLagIcon d-block">X</span>
                  ) : (
                    <FaPlus className="addLagIcon" fontSize={12} />
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {/* Navigation buttons */}
        <div className="navigation-buttons d-flex gap-3 mt-3">
          <AuthOutlineBtn onClick={handleBackStep} disabled={step === 0}>
            Back
          </AuthOutlineBtn>
          <AuthFillButton onClick={handleSubmitLag}>Next</AuthFillButton>
        </div>
      </div>

      {/* Image container */}
      <div className="steper-image-container lag-img h-md-100">
        <img src={languageImage} alt="languageImage" />
      </div>
    </div>
  );
}
